@file:OptIn(InternalResourceApi::class)

package com.flowyride.core.map.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/com.flowyride.core.map.resources/"

@delegate:ResourceContentHash(-1_979_910_770)
internal val Res.drawable.ic_speed_camera: DrawableResource by lazy {
      DrawableResource("drawable:ic_speed_camera", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_speed_camera.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_speed_camera", Res.drawable.ic_speed_camera)
}
